import { connect } from '@vfde-sails/core';
import * as mapDispatch from 'Container/App/action';
import { TariffHtmlId } from '../../enums/elementId';
import { selectors as mapStateToProps } from 'Container/App/selector';
import { mountOptionPicker, updateTariffOptionPicker } from '../../components/optionPicker';
import { mountVerticalList, updateTariffBenefits } from '../../components/verticalList';
import { trackPageView } from '../../util/tracking';
import { updatePageUrl } from '../../util/url';
import { mountHorizontalList, updateTariffLinks } from '../../components/horizontalList';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { updateSeal } from '../../util/seal';

type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

const getUpdateFlags = (state: State, oldState: State) => {
    const { tariffs, avcResult, selected } = state;

    return {
        tariffs: tariffs && tariffs !== oldState.tariffs,
        avcResult: avcResult !== oldState.avcResult,
        tariffChanged: selected.tariff && selected.tariff.id !== oldState.selected.tariff?.id,
        tariffIdChanged: selected.tariffId && selected.tariffId !== oldState.selected.tariffId,
    };
};

function container (_: State, actions: Actions) {

    const tariffOptionPicker = mountOptionPicker(TariffHtmlId.TARIFF_PICKER, (value: string) =>
        actions.setSelectedTariffId(value));
    const tariffBenefits = mountVerticalList(TariffHtmlId.BENEFITS_LIST);
    const tariffLinks = mountHorizontalList(TariffHtmlId.LINKS_LIST);

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const {
                tariffs,
                avcResult,
                selected,
                contentEnabled,
                gigakombi,
                ff,
                accessSupplier,
                address,
            } = newState;

            const update = getUpdateFlags(newState, oldState);

            if (update.tariffs || update.avcResult || update.tariffChanged) {
                updateSeal(selected.tariffId, accessSupplier, contentEnabled, !!address);
                updateTariffOptionPicker(
                    tariffOptionPicker,
                    tariffs,
                    avcResult?.metacodes,
                    selected.tariffId
                );
                updateTariffBenefits(tariffBenefits, selected.tariffId, avcResult);
                updateTariffLinks(tariffLinks, selected.tariff);
                toggleElementVisibilityById(TariffHtmlId.BENEFITS, contentEnabled);
            }

            update.tariffIdChanged && updatePageUrl(gigakombi, selected.tariffId);
            update.tariffChanged && trackPageView(selected.tariff!, gigakombi, ff, avcResult);
        },
    };
}

const Container = connect(mapStateToProps, mapDispatch)(container);

export default Container;
